import api from "./api";
export const getAllEmployesBasedOnStateDistrict = async (state, district) => {
    // Build the base URL
    let url = `/api/employee-posting/filter-based-state?stateId=${state}`;
    
    // Add districtId to the URL if district is provided
    if (district) {
        url += `&districtId=${district}`;
    }

    // Make the API request
    const response = await api.get(url);
    return response.data;
};


export const sendResignationMail = async (empId, formDataToSend) => {
  try {
    const response = await api.post(`/api/resignations/${empId}`, formDataToSend, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to send resignation mail:', error.response?.data || error.message);
    throw error; // Let caller handle alert
  }
};